function FormatNumeroCelular (numero) {
  return numero.replace(/\D/g, '')
}

export default FormatNumeroCelular
